export default __webpack_public_path__ + "static/media/Gloves of the Dark Messenger.8921f7ad.jpg";